import { Contact } from '@/shared/types/api'
import { matchesSystemBotContactSearch } from '@/shared/utils/contacts'

export const searchContact = (c: Contact, search: string, searchByNumber: boolean): boolean => {
  if (matchesSystemBotContactSearch(c, search)) {
    return true
  }

  if (searchByNumber) {
    return c.internalNumber.toString().includes(search.toLowerCase()) || !!c.mobilePhone?.toString().includes(search.toLowerCase())
  }

  const tokens = search.toLowerCase().trim().split(/\s+/).filter(Boolean)
  const haystack = [c.name, c.lastName, c.firstName, c.middleName]
    .filter(Boolean)
    .map(field => field!.toLowerCase())

  return tokens.every(token => haystack.some(field => field.includes(token)))
}
